import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import ConfirmationModal from "../../../../../../../../../components/Dialogs/ConfirmationModal";
import { Color } from "../../../../../../../../../components/Form/Button";
import useStyles from "./styles";

export interface DeleteBrandConfirmationModalHandles {
  open: (id: number[], brandName?: string) => void;
  close: () => void;
}
interface DeleteBrandConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: (id: number[]) => void;
  loadingAction?: boolean;
}

const DeleteBrandConfirmationModal: ForwardRefRenderFunction<
  DeleteBrandConfirmationModalHandles,
  DeleteBrandConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [idValues, setIdValues] = useState<number[]>([]);
  const [brandName, setBrandName] = useState<string>("s");

  const open = useCallback((id: number[], brandName?: string) => {
    if (id && id?.length) setIdValues(id);
    setBrandName(brandName || "");
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setIdValues([]);
    setBrandName("");
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));
  const onClose = () => {
    if (closeModal) closeModal();
    close();
  };
  const onDelete = () => {
    onSubmit(idValues);
  };

  return (
    <ConfirmationModal
      data-cy="deleteModal"
      width="520px !important"
      open={openModal}
      closeModal={onClose}
      type="error"
      title={idValues.length === 1 ? translate("deleteBrandName") : translate("deleteBrandNames")}
      leftIconTitle={<MdOutlineCancel color="#F04438" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
      textCancel={translate("cancel")}
      textSubmit={translate("delete")}
      submit={onDelete}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.cancelModalContainer}>
          <div data-cy="confirmationModalCancelBody" className={classes.descriptionModalConfirm}>
            <span>
              {idValues.length === 1
                ? `${translate("areYouSureYouWantToDeleteTheBrandName")} "${brandName}"`
                : `${translate("areYouSureYouWantToDeleteThese")} ${
                    idValues?.length || 0
                  } ${translate("brandNames")}`}
              ?
            </span>
            <span className="error">{translate("thisActionIsPermanentAndCannotBeUndone")}</span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(DeleteBrandConfirmationModal);
